import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=65032f5c&scoped=true&"
import script from "./HeaderBlock.vue?vue&type=script&lang=js&"
export * from "./HeaderBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBlock.vue?vue&type=style&index=0&id=65032f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65032f5c",
  null
  
)

export default component.exports